/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "name": "Do not shift pasted items",
  "description": "Paste copied items at their original position instead of shifted slightly in the costume editor.",
  "credits": [
    {
      "name": "GarboMuffin"
    }
  ],
  "dynamicEnable": true,
  "dynamicDisable": true,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "tags": [],
  "enabledByDefault": false
};
export default manifest;
